import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { useEsigningProviders } from 'app/domains/esigning/hooks/useEsigningProviders';
import { SignRequestStatus } from 'shared/domains/apollo/generated/types';
import { GetActiveEsigningProviderDocument } from './query.gql';
const TERMINAL_STATUSES = [
    SignRequestStatus.Cancelled,
    SignRequestStatus.Rejected,
    SignRequestStatus.Failed,
    SignRequestStatus.Unknown,
];
/**
 * Returns the eSigning provider that should be used for the current document.
 * If the document has an active (non-terminal) sign request, the provider that
 * was used for that request is returned. Otherwise falls back to the company's
 * currently connected provider.
 */
export function useActiveEsigningProvider() {
    var _a, _b;
    // TODO: https://linear.app/pocketsolutions/issue/PL-2134/prod-bug-shennanigans
    const { id: documentId = '' } = useParams();
    const { data } = useQuery(GetActiveEsigningProviderDocument, {
        variables: { documentId },
        // Skip the query if the document ID is not available
        skip: !documentId,
    });
    const { connectedProvider, providers } = useEsigningProviders();
    const lastSignRequest = (_b = (_a = data === null || data === void 0 ? void 0 : data.fileSystemDocument) === null || _a === void 0 ? void 0 : _a.lastSignRequest) !== null && _b !== void 0 ? _b : null;
    const hasActiveSignRequest = lastSignRequest !== null && !TERMINAL_STATUSES.includes(lastSignRequest.status);
    const provider = hasActiveSignRequest
        ? providers.find((p) => p.id === lastSignRequest.esigningProviderId)
        : connectedProvider;
    return { provider };
}
